import modalStyles from '../../components/modal/modal.module.scss';
import {useIsNavigatingOrPending} from '../../support/use_is_navigating_or_pending';
import {__} from '../../support/lang/translations';
import React, {useCallback} from 'react';
import {useClickOutside} from '../../support/use_click_outside.ts';
import {Button} from '../button/button.tsx';
import {Vehicle} from '../../gql/customer/graphql.ts';
import {useAppDispatch, useAppSelector} from '../../store/store.ts';
import {deleteVehicle} from '../../store/slices/me_slice.ts';
import {formatLicensePlate} from '../../support/license_plates/license_plate_formatter.ts';
import {ButtonColorType} from '../../enums/button_color_type.ts';

interface OwnProps {
    onCloseModal: () => void;
    onRedirect?: () => void;
    vehicle: Vehicle;
}

export function DeleteVehicleModal(props: OwnProps) {
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);
    const ref = React.useRef<HTMLDivElement | null>(null);
    const {onCloseModal} = props;
    const closeModalCallback = useCallback(() => {
        onCloseModal();
    }, [onCloseModal]);
    useClickOutside(ref, closeModalCallback);
    const customerToken = useAppSelector((state) => state.exchangeToken.token);
    const dispatch = useAppDispatch();

    if (customerToken === null) {
        return null;
    }

    const deleteVehicleClick = async () => {
        if (props.vehicle.id) {
            dispatch(deleteVehicle({token: customerToken, id: props.vehicle.id}));
            props.onCloseModal();
        }
        if (props.onRedirect) {
            props.onRedirect();
        }
    };

    return (
        <div className={modalStyles.modal_backdrop}>
            <div className={modalStyles.modal}>
                <div className={modalStyles.modal_dialog} ref={ref}>
                    <div className={modalStyles.modal_header}>
                        <span />
                        <h2>{__('vehicles.modals.titles.delete')}</h2>
                        <button disabled={isLoading} type="button" onClick={() => props.onCloseModal()}>
                            <i className="fa-light fa-close"></i>
                        </button>
                    </div>
                    <div className={modalStyles.modal_body}>
                        <p style={{margin: '0 0 2rem 0'}}>
                            {__('vehicles.modals.explanations.delete_vehicle', {
                                license_plate: formatLicensePlate(
                                    props.vehicle.identifiers?.find(
                                        (identifier) => identifier?.type === 'license_plate',
                                    )?.value ?? '',
                                ),
                            })}
                        </p>
                        <div className={modalStyles.modal_footer}>
                            <div>
                                <div>
                                    <Button
                                        type="button"
                                        onClick={() => props.onCloseModal()}
                                        colorType={ButtonColorType.Black}
                                    >
                                        <i className="fa-light fa-cancel" />
                                        <span>{__('vehicles.modals.buttons.cancel')}</span>
                                    </Button>
                                </div>
                            </div>
                            <div>
                                <Button type="button" loading={isLoading} onClick={() => deleteVehicleClick()}>
                                    <i className={isLoading ? 'fa-light fa-refresh' : 'fa-light fa-trash'} />
                                    <span>{__('vehicles.modals.buttons.delete')}</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
